import { ApiLinkEntity, ApiLinkRel, EMPTY_GUID } from "config/constants"
import { Coordinates, Guid, IApiLink, IMultipleEntitiesResponse } from "@/types"
import { ITenantWarehouseDto, TenantWarehouse } from "./TenantWarehouse"
import LocationService from "services/LocationService"

export interface IGetTenantWarehousesDto extends IMultipleEntitiesResponse<ITenantWarehouseDto> {
    noWarehouseId: Guid
}

export default class TenantWarehouses {
    entities: TenantWarehouse[]
    noWarehouseId: Guid
    linkCreate?: IApiLink
    linkUpdate?: IApiLink

    constructor(dto: IGetTenantWarehousesDto) {
        this.entities = dto.entities?.map(mcDto => new TenantWarehouse(mcDto)) || []
        this.noWarehouseId = dto.noWarehouseId
        this.linkCreate = dto.links?.find(lnk => lnk.entity === ApiLinkEntity.warehouse && lnk.rel === ApiLinkRel.new)
        this.linkUpdate = dto.links?.find(lnk => lnk.entity === ApiLinkEntity.warehouse && lnk.rel === ApiLinkRel.update)
    }

    get isNoWarehouseIdEmpty() {
        return this.noWarehouseId === EMPTY_GUID
    }

    getWarehouseByCoordinates(coordinates: Coordinates, radiusMeters: number): TenantWarehouse | null {
        return this.entities.find(wh => LocationService.isLocationInGeofenceRadius({ center: wh.location, radius: radiusMeters, location: coordinates })) || null
    }
}
